import { defineStore } from 'pinia';

interface CreditCard {
    id?: string;
    color: string;
    isDefault: boolean;
    month: string;
    name: string;
    number: string;
    type: string;
    year: string;
    bin: string;
    alias?: string;
}

interface UserState {
    users: Record<string, any> | { loading: boolean };
    language: string;
}

export const useUsersStore = defineStore({
    id: 'users',
    state: (): UserState => ({
        users: {},
        language: (navigator.language || navigator.languages[0]).split('-')[0]
    }),
    actions: {
        async getUserForEmail(email: string) {
            this.users = { loading: true };
            const baseUrl = useRuntimeConfig().public.apiBase;
            // #TODO: Consultar el email por Body, no por URL
            return fetchAppWrapper.get(`${baseUrl}/base/users/?email=${email}`)
                .then((data)=> {return data })
                .catch(error => {
                    throw error;
                })
        },
        async getUserForUsername(username: string) {
            this.users = { loading: true };
            const baseUrl = useRuntimeConfig().public.apiBase;
            // #TODO: Consultar el username por Body, no por URL
            return fetchAppWrapper.get(`${baseUrl}/base/users/?username=${username}`)
                .then((data)=> {return data })
                .catch(error => {
                    throw error;
                })
        },

        async setLanguage(lang: string){
            this.language = lang
        }
    },
    getters: {
        
    },
    persist: {
        storage: persistedState.localStorage,
    },
});